import styled from "@emotion/styled/macro";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import {ContentLayout} from "../../../components/ui/ContentLayout";

const Wrapper = styled(ContentLayout)`
  flex-direction: column;
  display: flex;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    //padding: 2.5em;
    justify-content: space-between;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    //padding : 3.375em 1.5em;
  }
`;

const Label = styled.p`
  //text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
`;

const LearnMore = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 2.375em;
    width: 7.5em;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 2em 0 0;
  }
  border: 1px solid ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  padding: 0.35em 0;
  text-align: center;
`;

const Container = styled.div`
  background: ${({ theme }) => theme.colors.aero};
  padding: 2em 0;
`;

const Legal = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Wrapper>
        <Label>{t("legal.learnText")}</Label>
        <LearnMore>
          <NavLink to={"/legal"}>{t("common.learnButton")}</NavLink>
        </LearnMore>
      </Wrapper>
    </Container>
  );
};

export default Legal;
